import { SummaryMetricConfigItem } from "../types/summaryDashboard.types";

export const SUMMARY_METRICS: SummaryMetricConfigItem[] = [
  {
    id: "totalListings",
    label: "Total listings",
    description: "Total number of open listings",
    tone: "primary",
    bgClass: "bg-primary-subtle",
    textClass: "text-primary-emphasis",
    defaultViewType: "chart-table",
    tableType: "listings",
    chartColor: "#5872C0"
  },
  {
    id: "activeListings",
    label: "Active listings",
    description: "Number of active listings with stock",
    tone: "success",
    bgClass: "bg-success-subtle",
    textClass: "text-success-emphasis",
    defaultViewType: "chart-table",
    tableType: "listings",
    chartColor: "#9EC97E"
  },
  {
    id: "outOfStock",
    label: "Out of stock",
    description: "Number of listings that are out of stock",
    tone: "danger",
    bgClass: "bg-danger-subtle",
    textClass: "text-danger-emphasis",
    defaultViewType: "table",
    tableType: "listings",
    chartColor: "#DE6F6A"
  },
  {
    id: "pricesGoUp",
    label: "Prices go up",
    description: "Number of listings that have increased in price in the last 30 days",
    tone: "primary",
    bgClass: "bg-primary-subtle",
    textClass: "text-primary-emphasis",
    defaultViewType: "chart-table",
    tableType: "listings",
    chartColor: "#5872C0"
  },
  {
    id: "pricesGoDown",
    label: "Prices go down",
    description: "Number of listings that have had their price lowered in the last 30 days",
    tone: "primary",
    bgClass: "bg-primary-subtle",
    textClass: "text-primary-emphasis",
    defaultViewType: "chart-table",
    tableType: "listings",
    chartColor: "#5872C0"
  },
  {
    id: "listingsSalesGoUp",
    label: "Listings sales go up",
    description: "Number of listings that saw sales increase over the last 30 days",
    tone: "success",
    bgClass: "bg-success-subtle",
    textClass: "text-success-emphasis",
    defaultViewType: "table",
    tableType: "listings",
    chartColor: "#9EC97E"
  },
  {
    id: "listingsLessThan6Pics",
    label: "Listings less than 6 pics",
    description: "Number of listings with one, two, three, four, five, six, seven, eight pictures ",
    tone: "warning",
    bgClass: "bg-warning-subtle",
    textClass: "text-warning-emphasis",
    defaultViewType: "chart-table",
    tableType: "listings",
    chartColor: "#F4C86B"
  },
  {
    id: "titleLessThan150Chars",
    label: "Title less than 150 chars",
    description: "Title less than 50, 100, 150 charcters",
    tone: "warning",
    bgClass: "bg-warning-subtle",
    textClass: "text-warning-emphasis",
    defaultViewType: "table",
    tableType: "listings",
    chartColor: "#F4C86B"
  },
  {
    id: "bulletsLessThan5",
    label: "Bullets less than 5",
    description: "Bullets less than 1, 2, 3, 4, 5",
    tone: "warning",
    bgClass: "bg-warning-subtle",
    textClass: "text-warning-emphasis",
    defaultViewType: "table",
    tableType: "listings",
    chartColor: "#F4C86B"
  },
  {
    id: "listingsNoReviews",
    label: "Listings no reviews",
    description: "Listings with no review, less than 10, 20,30,50,100,200,300,500,1000",
    tone: "danger",
    bgClass: "bg-danger-subtle",
    textClass: "text-danger-emphasis",
    defaultViewType: "table",
    tableType: "listings",
    chartColor: "#DE6F6A"
  },
  {
    id: "totalSalesGoDown",
    label: "Total sales go down",
    description: "Total sales",
    tone: "danger",
    bgClass: "bg-danger-subtle",
    textClass: "text-danger-emphasis",
    defaultViewType: "chart",
    chartColor: "#9EC97E"
  },
  {
    id: "totalProfit",
    label: "Total profit",
    description: "Total profit",
    tone: "success",
    bgClass: "bg-primary-subtle",
    textClass: "text-primary-emphasis",
    defaultViewType: "chart",
    chartColor: "#9EC97E"
  },
  {
    id: "listingsWithoutAds",
    label: "Listings without ads",
    description: "Types of ads not launched on listings",
    tone: "danger",
    bgClass: "bg-danger-subtle",
    textClass: "text-danger-emphasis",
    defaultViewType: "table",
    tableType: "listings",
    chartColor: "#DE6F6A"
  },
  {
    id: "listingsAdsCampaignsLessThan5",
    label: "Listings ads campaigns less than 5",
    description: "Number of campaigns for listing",
    tone: "warning",
    bgClass: "bg-warning-subtle",
    textClass: "text-warning-emphasis",
    defaultViewType: "table",
    tableType: "listings",
    chartColor: "#F4C86B"
  },
  {
    id: "adsCampaignsWithBadAcos",
    label: "Ads campaigns with bad ACOS",
    description: "Campaigns with ACoS more than 50%, 65%, 100%",
    tone: "danger",
    bgClass: "bg-danger-subtle",
    textClass: "text-danger-emphasis",
    defaultViewType: "chart-table",
    tableType: "campaigns",
    chartColor: "#DE6F6A"
  },
  {
    id: "adsAutopilotActivity",
    label: "Ads autopilot activity",
    description: "Ads autopilot statistics for last 30 days",
    tone: "primary",
    bgClass: "bg-primary-subtle",
    textClass: "text-primary-emphasis",
    defaultViewType: "chart-table",
    tableType: "events",
    chartColor: "#5872C0"
  },
  {
    id: "negativeWords",
    label: "Negative words",
    description: "Number of campaigns with negative words",
    tone: "primary",
    bgClass: "bg-primary-subtle",
    textClass: "text-primary-emphasis",
    defaultViewType: "table",
    tableType: "campaigns",    
    chartColor: "#5872C0"
  },
];
